export const getCookieURL = () => import.meta.env.VITE_APP_COOKIE_URL;
